import request from '@/utils/request'

// Admin/trainer management of a target user's saved places (kayıtlı yerler).
// Backend: /api/v2/user-locations/:targetUserId (auth: admin OR trainer-with-access).

export const getUserLocations = (targetUserId: string, search?: string) =>
  request({
    url: `/user-locations/${targetUserId}`,
    method: 'get',
    params: search ? { search } : {}
  })

export const saveUserLocation = (
  targetUserId: string,
  data: { latitude: number; longitude: number; title?: string; address?: string; locationType?: string }
) =>
  request({
    url: `/user-locations/${targetUserId}`,
    method: 'post',
    data
  })

export const updateUserLocation = (
  targetUserId: string,
  locationId: string,
  data: { title?: string; address?: string }
) =>
  request({
    url: `/user-locations/${targetUserId}/${locationId}`,
    method: 'put',
    data
  })

export const deleteUserLocation = (targetUserId: string, locationId: string) =>
  request({
    url: `/user-locations/${targetUserId}/${locationId}`,
    method: 'delete'
  })
